var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoins(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 11.8203V12.7578C9.375 13.8266 10.8125 14.6328 12.6875 14.6328C14.5625 14.6328 16 13.8266 16 12.7578V11.8203H9.375Z",
    fill: "#FEA832"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 11.8203V12.7578C9.375 13.8266 10.8125 14.6328 12.6875 14.6328V11.8203H9.375Z",
    fill: "#FE9923"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 10.8828V11.8203C9.375 12.8891 10.8125 13.6953 12.6875 13.6953C14.5625 13.6953 16 12.8891 16 11.8203V10.8828H9.375Z",
    fill: "#FEA832"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 10.8828V11.8203C9.375 12.8891 10.8125 13.6953 12.6875 13.6953V10.8828H9.375Z",
    fill: "#FE9923"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 10.8828V11.8203C9.375 12.8891 10.8125 13.6953 12.6875 13.6953C14.5625 13.6953 16 12.8891 16 11.8203V10.8828H9.375Z",
    fill: "#FEDB41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 10.8828V11.8203C9.375 12.8891 10.8125 13.6953 12.6875 13.6953V10.8828H9.375Z",
    fill: "#FFCC33"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 9.94531V10.8828C9.375 11.9516 10.8125 12.7578 12.6875 12.7578C14.5625 12.7578 16 11.9516 16 10.8828V9.94531H9.375Z",
    fill: "#FEA832"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 9.94531V10.8828C9.375 11.9516 10.8125 12.7578 12.6875 12.7578V9.94531H9.375Z",
    fill: "#FE9923"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 9.00781V9.94531C9.375 11.0141 10.8125 11.8203 12.6875 11.8203C14.5625 11.8203 16 11.0141 16 9.94531V9.00781H9.375Z",
    fill: "#FEDB41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 9.00781V9.94531C9.375 11.0141 10.8125 11.8203 12.6875 11.8203V9.00781H9.375Z",
    fill: "#FFCC33"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 8.07031V9.00781C9.375 10.0766 10.8125 10.8828 12.6875 10.8828C14.5625 10.8828 16 10.0766 16 9.00781V8.07031H9.375Z",
    fill: "#FEA832"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 8.07031V9.00781C9.375 10.0766 10.8125 10.8828 12.6875 10.8828V8.07031H9.375Z",
    fill: "#FE9923"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 7.13281V8.07031C9.375 9.13906 10.8125 9.94531 12.6875 9.94531C14.5625 9.94531 16 9.13906 16 8.07031V7.13281H9.375Z",
    fill: "#FEDB41"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 7.13281V8.07031C9.375 9.13906 10.8125 9.94531 12.6875 9.94531V7.13281H9.375Z",
    fill: "#FFCC33"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 6.19531V7.13281C9.375 8.20156 10.8125 9.00781 12.6875 9.00781C14.5625 9.00781 16 8.20156 16 7.13281V6.19531H9.375Z",
    fill: "#FEA832"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 6.19531V7.13281C9.375 8.20156 10.8125 9.00781 12.6875 9.00781V6.19531H9.375Z",
    fill: "#FE9923"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 5.25781V6.19531C9.375 7.26406 10.8125 8.07031 12.6875 8.07031C14.5625 8.07031 16 7.26406 16 6.19531V5.25781H9.375Z",
    fill: "#FEDB41"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 5.25781V6.19531C9.375 7.26406 10.8125 8.07031 12.6875 8.07031V5.25781H9.375Z",
    fill: "#FFCC33"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 4.32031V5.25781C9.375 6.32656 10.8125 7.13281 12.6875 7.13281C14.5625 7.13281 16 6.32656 16 5.25781V4.32031H9.375Z",
    fill: "#FEA832"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 4.32031V5.25781C9.375 6.32656 10.8125 7.13281 12.6875 7.13281V4.32031H9.375Z",
    fill: "#FE9923"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 3.38281V4.32031C9.375 5.38906 10.8125 6.19531 12.6875 6.19531C14.5625 6.19531 16 5.38906 16 4.32031V3.38281H9.375Z",
    fill: "#FEDB41"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 3.38281V4.32031C9.375 5.38906 10.8125 6.19531 12.6875 6.19531V3.38281H9.375Z",
    fill: "#FFCC33"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 2.44531V3.38281C9.375 4.45156 10.8125 5.25781 12.6875 5.25781C14.5625 5.25781 16 4.45156 16 3.38281V2.44531H9.375Z",
    fill: "#FEA832"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 2.44531V3.38281C9.375 4.45156 10.8125 5.25781 12.6875 5.25781V2.44531H9.375Z",
    fill: "#FE9923"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6875 0.570312C14.5625 0.570312 16 1.37656 16 2.44531C16 3.51406 14.5625 4.32031 12.6875 4.32031C10.8125 4.32031 9.375 3.51406 9.375 2.44531C9.375 1.37656 10.8125 0.570312 12.6875 0.570312Z",
    fill: "#FEDB41"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 2.44531C9.375 3.51406 10.8125 4.32031 12.6875 4.32031V0.570312C10.8125 0.570312 9.375 1.37656 9.375 2.44531Z",
    fill: "#FFCC33"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8125 11.8203V12.7578C2.8125 13.8266 4.21875 14.6328 6.09375 14.6328C7.96875 14.6328 9.375 13.8266 9.375 12.7578V11.8203H2.8125Z",
    fill: "#FEA832"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8125 11.8203V12.7578C2.8125 13.8266 4.21875 14.6328 6.09375 14.6328V11.8203H2.8125Z",
    fill: "#FE9923"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8125 10.8828V11.8203C2.8125 12.8891 4.21875 13.6953 6.09375 13.6953C7.96875 13.6953 9.375 12.8891 9.375 11.8203V10.8828H2.8125Z",
    fill: "#FEDB41"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8125 10.8828V11.8203C2.8125 12.8891 4.21875 13.6953 6.09375 13.6953V10.8828H2.8125Z",
    fill: "#FFCC33"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8125 9.94531V10.8828C2.8125 11.9516 4.21875 12.7578 6.09375 12.7578C7.96875 12.7578 9.375 11.9516 9.375 10.8828V9.94531H2.8125Z",
    fill: "#FEA832"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8125 9.94531V10.8828C2.8125 11.9516 4.21875 12.7578 6.09375 12.7578V9.94531H2.8125Z",
    fill: "#FE9923"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8125 9.00781V9.94531C2.8125 11.0141 4.21875 11.8203 6.09375 11.8203C7.96875 11.8203 9.375 11.0141 9.375 9.94531V9.00781H2.8125Z",
    fill: "#FEDB41"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8125 9.00781V9.94531C2.8125 11.0141 4.21875 11.8203 6.09375 11.8203V9.00781H2.8125Z",
    fill: "#FFCC33"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8125 8.07031V9.00781C2.8125 10.0766 4.21875 10.8828 6.09375 10.8828C7.96875 10.8828 9.375 10.0766 9.375 9.00781V8.07031H2.8125Z",
    fill: "#FEA832"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8125 8.07031V9.00781C2.8125 10.0766 4.21875 10.8828 6.09375 10.8828V8.07031H2.8125Z",
    fill: "#FE9923"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8125 7.13281V8.07031C2.8125 9.13906 4.21875 9.94531 6.09375 9.94531C7.96875 9.94531 9.375 9.13906 9.375 8.07031V7.13281H2.8125Z",
    fill: "#FEDB41"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8125 7.13281V8.07031C2.8125 9.13906 4.21875 9.94531 6.09375 9.94531V7.13281H2.8125Z",
    fill: "#FFCC33"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8125 6.19531V7.13281C2.8125 8.20156 4.21875 9.00781 6.09375 9.00781C7.96875 9.00781 9.375 8.20156 9.375 7.13281V6.19531H2.8125Z",
    fill: "#FEA832"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8125 6.19531V7.13281C2.8125 8.20156 4.21875 9.00781 6.09375 9.00781V6.19531H2.8125Z",
    fill: "#FE9923"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8125 5.25781V6.19531C2.8125 7.26406 4.21875 8.07031 6.09375 8.07031C7.96875 8.07031 9.375 7.26406 9.375 6.19531V5.25781H2.8125Z",
    fill: "#FEDB41"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8125 5.25781V6.19531C2.8125 7.26406 4.21875 8.07031 6.09375 8.07031V5.25781H2.8125Z",
    fill: "#FFCC33"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8125 4.32031V5.25781C2.8125 6.32656 4.21875 7.13281 6.09375 7.13281C7.96875 7.13281 9.375 6.32656 9.375 5.25781V4.32031H2.8125Z",
    fill: "#FEA832"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8125 4.32031V5.25781C2.8125 6.32656 4.21875 7.13281 6.09375 7.13281V4.32031H2.8125Z",
    fill: "#FE9923"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M6.09375 2.44531C7.96875 2.44531 9.375 3.25156 9.375 4.32031C9.375 5.38906 7.96875 6.19531 6.09375 6.19531C4.21875 6.19531 2.8125 5.38906 2.8125 4.32031C2.8125 3.25156 4.21875 2.44531 6.09375 2.44531Z",
    fill: "#FEDB41"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8125 4.32031C2.8125 5.38906 4.21875 6.19531 6.09375 6.19531V2.44531C4.21875 2.44531 2.8125 3.25156 2.8125 4.32031Z",
    fill: "#FFCC33"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 7.92969C5.82191 7.92969 7.5 9.60784 7.5 11.6797C7.5 13.7516 5.82191 15.4297 3.75 15.4297C1.67809 15.4297 0 13.7516 0 11.6797C0 9.60784 1.67809 7.92969 3.75 7.92969Z",
    fill: "#FEA832"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.6797C0 13.7516 1.67809 15.4297 3.75 15.4297V7.92969C1.67809 7.92969 0 9.60784 0 11.6797Z",
    fill: "#FE9923"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 8.86719C5.29691 8.86719 6.5625 10.1328 6.5625 11.6797C6.5625 13.2266 5.29691 14.4922 3.75 14.4922C2.20309 14.4922 0.9375 13.2266 0.9375 11.6797C0.9375 10.1328 2.20309 8.86719 3.75 8.86719Z",
    fill: "#FEDB41"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M0.9375 11.6797C0.9375 13.2266 2.20309 14.4922 3.75 14.4922V8.86719C2.20309 8.86719 0.9375 10.1328 0.9375 11.6797Z",
    fill: "#FFCC33"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoins);
export default __webpack_public_path__ + "static/media/Coins.b4bccc497008d3c3b131ba1fa1bbe5b3.svg";
export { ForwardRef as ReactComponent };